import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { TOOLS } from '../../data/tools';
import { SectionHeading } from '../ui/SectionHeading';
import { ToolCard } from '../tools/ToolCard';
import { trackEvent } from '../../utils/analytics';
export function ToolsGallery() {
  const featured = TOOLS.filter(tool => tool.featured);
  const others = TOOLS.filter(tool => !tool.featured);
  const track = (slug: string, tier: string) => () => trackEvent('tool_card_click', {
    tool: slug,
    placement: `home_tools_${tier}`
  });
  return <section id="tools" aria-labelledby="tools-gallery-heading" className="scroll-mt-20 border-b border-hairline-soft bg-ink" data-id="element-223" data-mp="2k6fpdxxv4d15">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-224" data-mp="2o79cwq7e7pti">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-225" data-mp="iejfstv99d90">
          <SectionHeading eyebrow="Tools" headingId="tools-gallery-heading" title="Start with the task on your desk." data-id="element-226" data-mp="mged7na2f6hi" />
          <Link to="/tools" className="inline-flex min-h-[44px] shrink-0 items-center gap-1.5 text-sm font-semibold text-lime hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-227" data-mp="fiplszxgv7p5">
            View All Tools
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-228" data-mp="kahh1nrki1lm" />
          </Link>
        </div>
        <ul className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-229" data-mp="3sprak7he5yhs">
          {featured.map(tool => <li key={tool.slug} data-id="element-230" data-mp="3nr6ac8253etc">
              <ToolCard tool={tool} variant="featured" onNavigate={track(tool.slug, 'featured')} data-id="element-231" data-mp="3nrzj1eknsee4" />
            </li>)}
        </ul>
        <ul className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-232" data-mp="6gq74e9xcfpd">
          {others.map(tool => <li key={tool.slug} data-id="element-233" data-mp="1m2o2uxowdi6">
              <ToolCard tool={tool} variant="compact" onNavigate={track(tool.slug, 'grid')} data-id="element-234" data-mp="1hx6owe8yb8fe" />
            </li>)}
        </ul>
      </div>
    </section>;
}